
export const getAvailableRegYears = (startYear : number, yearsBefore : number = 2, yearsAfter : number = 2) => {
    const availableRegYears : number[] = [];
    for(let year = startYear - yearsBefore; year <= startYear + yearsAfter; year++){
        availableRegYears.push(year);
    }

    return availableRegYears;
  };